export default "<div id=\"youtube-player-{{youtubeDivId}}\" style=\"width: 100%; height: 50vh;\"></div>\n\n";